import React from "react";
import { createRoot } from "react-dom/client";
import ResetDataSettingsPage from "./components/reset-data-form";
import EnvironmentI18n from "./providers/EnvironmentI18n";

export default (props: any) => {
   const container = document.getElementById("reset-data-react-mount");
   const root = createRoot(container!);
   root.render(
      <EnvironmentI18n locale={(window.I18n?.locale as any) ?? "en"}>
         <ResetDataSettingsPage {...props} />
      </EnvironmentI18n>,
   );
};
